<form [formGroup]="verificationForm()" *transloco="let t; prefix: 'registration.page.verificationForm'">
  <div class="form-container">
    <htx-form-section
      [title]="t('sections.companyData')"
      [icon]="'account_balance'"
      [formGroup]="verificationForm()"
      [showErrorSummary]="false"
      [fieldLabels]="verificationFormFieldLabels()"
    >
      <htx-datepicker-field-with-error
        [ctrl]="verificationForm().controls['foundingDate']"
        [label]="t('controls.foundingDate.label')"
        [required]="true"
        [errorMessages]="errorMessagesService.messages()"
      >
      </htx-datepicker-field-with-error>
      <htx-text-field-with-error
        [ctrl]="verificationForm().controls['taxIdNumber']"
        [label]="t('controls.taxIdNumber.label')"
        [required]="true"
        [errorMessages]="errorMessagesService.messages()"
      >
      </htx-text-field-with-error>
      <htx-text-field-with-error
        [ctrl]="verificationForm().controls['commercialRegisterCourt']"
        [label]="t('controls.commercialRegisterCourt.label')"
        [required]="true"
        [errorMessages]="errorMessagesService.messages()"
      >
      </htx-text-field-with-error>
      <htx-text-field-with-error
        [ctrl]="verificationForm().controls['commercialRegisterNumber']"
        [label]="t('controls.commercialRegisterNumber.label')"
        [required]="true"
        [errorMessages]="errorMessagesService.messages()"
      >
      </htx-text-field-with-error>
    </htx-form-section>

    <htx-form-section
      [title]="t('sections.documents')"
      [icon]="'upload_file'"
      [formGroup]="verificationForm()"
      [showErrorSummary]="false"
      [fieldLabels]="verificationFormFieldLabels()"
    >
      <htx-file-upload-field-with-error
        [ctrl]="verificationForm().controls['document']"
        [acceptedFileTypes]="'application/pdf'"
        [uploadText]="'PDF hochladen'"
        [dragDropText]="'oder hier ablegen (max. 10 MB)'"
        [errorMessages]="errorMessagesService.messages()"
      >
      </htx-file-upload-field-with-error>
    </htx-form-section>

    <htx-form-section
      [title]="t('sections.confirmation')"
      [icon]="'check_circle'"
      [formGroup]="verificationForm()"
      [showErrorSummary]="false"
      [fieldLabels]="verificationFormFieldLabels()"
    >
      <htx-checkbox-field-with-error
        [ctrl]="verificationForm().controls['hasAgreedToMembershipDeclaration']"
        [label]="t('controls.hasAgreedToMembershipDeclaration.text')"
        [required]="true"
        [errorMessages]="{ required: '' }"
      >
      </htx-checkbox-field-with-error>
      <htx-checkbox-field-with-error
        [ctrl]="verificationForm().controls['hasAgreedToDocumentUpload']"
        [label]="t('controls.hasAgreedToDocumentUpload.text')"
        [required]="true"
        [errorMessages]="{ required: '' }"
      >
      </htx-checkbox-field-with-error>
    </htx-form-section>
  </div>
</form>
